export default __webpack_public_path__ + "static/media/webDesign.38c3f01f.png";